import React from 'react'
import Picker from 'emoji-picker-react';
import SentimentVerySatisfiedIcon from '@material-ui/icons/SentimentVerySatisfied';
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import 'index.css';

class EmojiPicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      displayColorPicker: false,
      selectedEmoji: null,
    };
  }

  handleClick = () => this.setState({ displayEmojiPicker: !this.state.displayEmojiPicker })
  handleClose = () => this.setState({ displayEmojiPicker: false })
  handleChange = (event , emoji) => {
    this.props.onEmojiSelect({...event, emoji: emoji.emoji})
    this.handleClose()
  };

  render() {
    return (
      <>
        { this.state.displayEmojiPicker ?
          <ClickAwayListener onClickAway={this.handleClose}>
            <Picker onEmojiClick={this.handleChange} pickerStyle={{ position: 'absolute', top: -330, left: 30 }} />
          </ClickAwayListener>
          : null
        }
        <SentimentVerySatisfiedIcon onClick={ this.handleClick } />
      </>
    )
  }
}

export default EmojiPicker